import Request from '~/providers/Request';

export const fetchCorporations = async (input, page, resolve) => {
  await Request.get(`/admin/corporation?sort=name&direction=asc&qs=${input}&page=${page}`).then(resp => {
    const items = resp.data.map( e => ({
      id: Number(e.id),
      name: `${e.name}`
    }));
    resolve(
      {
        total_count: resp.meta.total,
        items
      }
    );
  });
};
